import React from 'react';

//CORE COMPONENTS
import { ThemeProvider, styled } from '../../../components-core/packages/components-core/dist/theme-provider/index';
import { 
    Container, 
    ContainerWrap, 
    ContainerPadding,
    ContainerGutter,
    ContainerHorizontalAlignment
} from '../../../components-core/packages/components-core/dist/container/index';
import { IntegratorRoot } from '../../../components-core/packages/components-core/dist/integrator-root/index';
import { 
    Text, 
    TextAppearance, 
    TextAlignment,
    TextColor
    
} from '../../../components-core/packages/components-core/dist/text';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';
import { Image } from '../../../components-core/packages/components-core/dist/image/index';
import { Layout, LayoutConfigurations } from '../../../components-core/packages/components-core/dist/layout/index';
import { Button,ButtonAppearance,} from '../../../components-core/packages/components-core/dist/button/index';
import { AspectRatioContainer, AspectRatio} from '../../../components-core/packages/components-core/dist/aspect-ratio-container';
import mobileImage from './mobile-img.png';
//ICONS CORE
import { Checkmark } from '../../../components-core/packages/icons-core/dist/Checkmark/index';
import { Link } from '../../../components-core/packages/components-core/dist';

const TopView = styled.div`
    width: 100vw;
    background: rgb(0,67,122);
    background: -moz-linear-gradient(325deg, rgba(0,67,122,1) 0%, rgba(0,30,80,1) 100%);
    background: -webkit-linear-gradient(325deg, rgba(0,67,122,1) 0%, rgba(0,30,80,1) 100%);
    background: linear-gradient(325deg, rgba(0,67,122,1) 0%, rgba(0,30,80,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#00437a",endColorstr="#001e50",GradientType=1);
`;

const CustomContainer = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;


const grid001 = ContainerPadding.grid001;
const grid002 = ContainerPadding.grid002;
const grid003 = ContainerPadding.grid003;
const grid004 = ContainerPadding.grid004;

const generalPadding = {
    [Breakpoints.default]: grid002,
    [Breakpoints.b960]: grid003,
    [Breakpoints.b1280]: grid004,
}

const singleColumnPadding = {
    [Breakpoints.default]: grid001,
    [Breakpoints.b560]: grid001,
}

/**
 * Bu kodu nasıl yazdığımı bir ben bir de Allah biliyor.
 * Bu komponenti 5-6 defa sıfırdan kodlamaya çalıştım fakat hiçbirinde başaramadım.
 * Bir tek bu çirkin kod çalıştı.
 * Kendine güveniyorsan sen de dene.
 */

class MobileAppDownloadSection extends React.Component {

    renderListItems() {
        return listItems.map(item => 
            <Container 
                wrap={ContainerWrap.never} 
                gutter={ContainerGutter.static150} 
            >
                <Checkmark variant={'small'} style={{ color: '#ffffff' }} />
                <Text appearance={TextAppearance.copy0150}>{item}</Text>
            </Container>
        )
    }

    renderLeftContainer() {
        
        const paddings = {
            left: {
                [Breakpoints.default]: grid002,
                [Breakpoints.b960]: grid002,
                [Breakpoints.b1280]: grid004
            },
            right: {
                [Breakpoints.default]: grid002,
                [Breakpoints.b960]: grid002,
                [Breakpoints.b1280]: grid001
            },
        }

        const alignments = {
            [Breakpoints.default]: ContainerHorizontalAlignment.center,
            [Breakpoints.b960]: ContainerHorizontalAlignment.flexStart,
            [Breakpoints.b1280]: ContainerHorizontalAlignment.center,
        }

        const textAlignments = {
            [Breakpoints.default]: TextAlignment.center,
            [Breakpoints.b960]: TextAlignment.left,
            [Breakpoints.b1280]: TextAlignment.center,
        }

        const TopText = (
            <Container 
                gutter={ContainerGutter.dynamic0100} 
                horizontalAlign={alignments}
            >
                <h2><Text 
                    appearance={TextAppearance.headline0350} 
                    textAlign={textAlignments}
                >
                    Mobil uygulamamızı <br /><b>denediniz mi?</b>
                </Text></h2>    
                <Text 
                    appearance={TextAppearance.copy0150} 
                    textAlign={textAlignments}
                >
                    Siz de hemen Volkswagen Ticari Araç mobil uygulamasını indirin, 
                    özel hizmetlerden faydalanın.
                </Text>
            </Container>
        )

        
        const ListItems = (
            <Container 
                wrap={ContainerWrap.always} 
                gutter={ContainerGutter.dynamic0050}    
            >
                {this.renderListItems()}
            </Container> 
        )

    const GooglePlayButton = (
            <Button appearance={ButtonAppearance.Primary}>
                <a style={{textDecoration:'none', color:'#001e50'}} href={'https://play.google.com/store/apps/details?id=tr.com.dteknoloji.vwticari&gl=TR'} target={'_blank'}>Google Play'den indir</a>  
            </Button>
            
    )
    const AppleStoreButton = (
        <Button appearance={ButtonAppearance.Primary}>
              <a style={{textDecoration:'none', color:'#001e50'}} href={'https://apps.apple.com/tr/app/volkswagen-ticari-ara%C3%A7/id1134858183?l=tr'} target={'_blank'}>Apple Store'dan indir&nbsp;&nbsp;</a> 
        </Button>
    )
            

        return(
            <CustomContainer>
                <Container                 
                    gutter={ContainerGutter.dynamic0100}
                    padding={paddings} 
                    horizontalAlign={alignments}
                >
                    {TopText}
                    <Container 
                        wrap={ContainerWrap.always} 
                        horizontalAlign={alignments}
                        gutter={ContainerGutter.dynamic0100}
                    >
                        <Container horizontalAlign={alignments}>
                            {ListItems}
                        </Container>
                        <Container horizontalAlign={alignments} gutter={ContainerGutter.static150}>
                            {AppleStoreButton}
                            {GooglePlayButton}
                        </Container>
                    </Container>
                </Container>
            </CustomContainer>
        )
    }

    renderRightContainer() {
        const padding = { 
            right: generalPadding, 
            left: singleColumnPadding,
        }

        return (
            <Container 
                padding={padding}
                horizontalAlign={ContainerHorizontalAlignment.center}
            >
                <Image src={mobileImage} />
            </Container>
        )
    }


    render() {
        const isMobile = typeof window !== `undefined` && window.innerWidth <= 768;

        return (
            <ThemeProvider theme={'inverted'}>
                <TopView>
                    <Container padding={{ top: ContainerPadding.dynamic0250, bottom: ContainerPadding.dynamic0250 }}>
                        <Layout appearance={LayoutConfigurations.half} rowGap={ContainerGutter.dynamic0250} >
                            {this.renderLeftContainer()}
                            {isMobile ? '' : this.renderRightContainer()}
                        </Layout>
                    </Container>
                </TopView>
            </ThemeProvider>
        )
    }
}

const listItems = [
    'Servis indirim oranınızı görün', 
    'Online servis randevunuzu kolayca alın',
    'Uyarı sembollerinin anlamlarını öğrenin',
    'Tek tıkla canlı yol yardıma bağlanın'
]

export default MobileAppDownloadSection;